/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { useIsKidAccount } from "@packages/sdk";

import { colors, spacing } from "../../../../../global/emotion";
import { Text } from "../Text/Text.emotion";

const buttonStyle: Interpolation = {
  backgroundColor: colors.transparent,
  border: "none",
  color: "inherit",
  cursor: "pointer",
  margin: spacing.none,
  padding: spacing.none,
};

export const FooterCookies = () => {
  const t = useTranslations();
  const { isKidAccount } = useIsKidAccount();

  if (isKidAccount) return null;

  return (
    <Text asChild size="xl" type="detail">
      <button
        css={buttonStyle}
        onClick={() =>
          (window.location.href = `${window.location.href.split("#")[0]}#cookie-manager`)
        }
      >
        {t("web_manage_cookies")}
      </button>
    </Text>
  );
};
